import React, { type FunctionComponent, Suspense } from 'react'
import { RouteSuspenseLoading } from './components/RouteSuspenseLoading'

export const RouteSuspense: FunctionComponent<React.PropsWithChildren<unknown>> = ({
  children,
}) => <Suspense fallback={<RouteSuspenseLoading />}>{children}</Suspense>
